const countryFlags = {
  Ghana: "/images/country/Ghana (GH).svg",
  Italy: "/images/country/Italy (IT).svg",
  Ireland: "/images/country/Ireland (IE).svg",
  Denmark: "/images/country/Denmark (DK).svg",
  Austria: "/images/country/Austria (AT).svg",
  China: "/images/country/China.svg",
  Australia: "/images/country/Cook Islands (CK).svg",
  France: "/images/country/Clipperton Island (CP).svg",
  Georgia: "/images/country/Georgia (GE).svg",
  Germany: "/images/country/Germany (DE).svg",
  Indonesia: "/images/country/Indonesia (ID).svg",
  // Add more as needed
};

export default countryFlags;
